var jade = require("/Users/nmd/dev/vsct.info/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (style) {
buf.push("<div class=\"row\"><div class=\"large-10 small-centered columns\"><form v-on=\"submit: submitForm\"" + (jade.cls([style.form], [true])) + "><div class=\"form-group\"><label>Имя пользователя</label><input type=\"text\" name=\"login\" v-attr=\"disabled:disabled\" v-model=\"login\" lazy required></div><div class=\"form-group\"><label>Пароль</label><input type=\"password\" name=\"password\" v-attr=\"disabled:disabled\" v-model=\"password\" lazy required></div><component is=\"alert\" data-name=\"login-form\" data-message=\"{{ data.message }}\"></component><button v-attr=\"disabled:disabled\" type=\"submit\"" + (jade.cls([style.btn], [true])) + ">Войти</button></form></div></div>");}.call(this,"style" in locals_for_with?locals_for_with.style:typeof style!=="undefined"?style:undefined));;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/login-form/template.jade
 ** module id = 109
 ** module chunks = 0
 **/